import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { CoreModule } from 'src/app/core/core.module';
import { SettingsComponent } from './settings.component';
import { SettingsRoutingModule } from './settings-routing.module';

@NgModule({
    declarations: [SettingsComponent],
    imports: [
        CommonModule,
        FormsModule,
        InputTextModule,
        CoreModule,
        SettingsRoutingModule,
    ],
})
export class SettingsModule {}
